import { Box, Tab, Tabs } from "@mui/material";
import React, { useEffect, useState } from "react";
import CleanerSalaryConfig from "./components/cleanersalaryconfig";

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


const CleanerSalaryMain: React.FC<any> = (props) => {

    const [value, setValue] = React.useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    return (
        <div>
            <div>
                <div style={{ width: "100%", marginTop: "35px", minWidth: "1500px" }}>
                    <Box sx={{ width: "100%", marginBottom: "0px" }}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                                <Tab label="청소 급여 내역" {...a11yProps(0)} />
                                {
                                    (props.user && props.user.todoistApiKey)
                                        ?
                                        <Tab label="청소 급여 설정" {...a11yProps(1)} />
                                        :
                                        ""
                                }
                            </Tabs>
                        </Box>
                    </Box>
                </div>

                {
                    value === 0
                    ?
                    <div>
                        
                    </div>
                    :
                    ""
                }
                {
                    value === 1
                    ?
                    <div>
                        <CleanerSalaryConfig user={props.user} />
                    </div>
                    :
                    ""
                }

            </div>
        </div>
    )
}

export default CleanerSalaryMain;